import type { ForumBase } from '../types/forum';
import { forumHasAnySelector } from './bulkScrapeReport';

export type ScrapeHealthIssue = {
  id: string;
  forum_id: string;
  name: string;
  kind: 'no_selector' | 'stale' | 'no_url';
  detail: string;
  daysSinceUpdate?: number;
};

export function analyzeScrapeHealth(
  forums: ForumBase[],
  staleDays = 14
): ScrapeHealthIssue[] {
  const issues: ScrapeHealthIssue[] = [];
  const now = Date.now();

  for (const f of forums) {
    if (!f.is_active) continue;
    if (!f.url?.trim()) {
      issues.push({
        id: f.id,
        forum_id: f.forum_id,
        name: f.name,
        kind: 'no_url',
        detail: 'URL tanımlı değil',
      });
    }
    if (!forumHasAnySelector(f)) {
      issues.push({
        id: f.id,
        forum_id: f.forum_id,
        name: f.name,
        kind: 'no_selector',
        detail: 'CSS seçici yok',
      });
    }
    const updated = f.updated_at || f.created_at;
    if (updated) {
      const days = Math.floor((now - new Date(updated).getTime()) / (86400000));
      if (days >= staleDays) {
        issues.push({
          id: f.id,
          forum_id: f.forum_id,
          name: f.name,
          kind: 'stale',
          detail: `${days} gündür güncellenmedi`,
          daysSinceUpdate: days,
        });
      }
    }
  }

  return issues;
}
